import React from 'react';
import Modal from 'react-modal';
import {atom,useAtom} from 'jotai';
import { Box, Circle, Flex,Heading } from '@chakra-ui/react';
import { FaTimes as CancelIcon } from 'react-icons/fa';

const customStyles = {
    content: {
      // top: '50%',
      // left: '50%',
      // right: 'auto',
      // bottom: 'auto',
      // marginRight: '-50%',
      // transform: 'translate(-50%, -50%)',
      // padding:'0',
      top:'0',
      left:'0',
      width:'100%',
      height:'100dvh',
      display:'flex',
      justifyContent:'center',
      // position:'fixed',
      padding:'0',
      margin:'0',
      background:'tranparent',
      bacgroundColor:'transprent',
     
    },
    overlay:{
      backgroundColor:'rgba(120, 187, 42,0.3)'
    }
  };

export type ModalType = {
  header:string;
  content:any;
  hasHead?:boolean;
}

Modal.setAppElement('#modal')
export const openAtom = atom<boolean>(false);
export const modalAtom = atom<ModalType>({
  header:'Header',
  content:'Content',
  hasHead:true,
});
const ModalContextProvider = (props:any) => {
    
    const [show_modal,handle_show_modal] = useAtom(openAtom);
    const [{header,content,hasHead = true}] = useAtom(modalAtom);
  return (
    <>
        {props.children}
        <Modal
            isOpen={show_modal}
            style={customStyles}
            
        >
            {<Flex justify="center" h="100dvh" sx={{overflow:'clip auto'}} pos="fixed" width="100%" pt="50px"  bg="transparent">
              <Box pos="relative" minW="400px" borderRadius="10px"  pb="30px" >
               {hasHead ? <Flex sx={{
                  background:`linear-gradient(to bottom,#335642 20%,#8DC467 60%)`,
                  padding:"20px",
                  borderRadius:'10px 10px 0 0',
                  
            
                }} align="center" justify="space-between" >
                    <Heading fontSize="1.4rem" color="var(--white-color)">{header}</Heading>
                    <Circle bg="rgba(255,255,255,0.4)" color="var(--white-color)" cursor="pointer" onClick={()=>handle_show_modal(false)} size="30px"><CancelIcon /></Circle>
                </Flex>:''}
                <Box sx={{
                  backgroundColor:'var(--white-background)',
                  padding:"20px",
                  borderRadius:'0 0 10px 10px'
                }}>
                  {content}
                </Box>
              </Box>
            </Flex>
            }
        </Modal>
    </>
  )
}

export default ModalContextProvider